/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { getColor, getShape } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((pd) => ({
  backdrop: {
    flex: 1,
    justifyContent: 'center' as const,
    // stretch + paddingHorizontal = exact 16px from screen (avoid width:'100%' + alignItems:center → 0 width)
    backgroundColor: getColor(pd.sys.colour.overlay),
    paddingHorizontal: pd.ref.space.spacing40.px,
    paddingVertical: pd.ref.space.spacing50.px,
  },
  backdropPressable: {
    position: 'absolute' as const,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  card: {
    alignSelf: 'stretch' as const,
    alignItems: 'center' as const,
    backgroundColor: getColor(pd.sys.colour.container_none),
    ...getShape(pd.sys.shape.corner.large),
    paddingHorizontal: pd.ref.space.spacing50.px,
    paddingTop: pd.ref.space.spacing50.px,
    paddingBottom: pd.ref.space.spacing50.px,
  },
  title: {
    textAlign: 'center' as const,
    alignSelf: 'stretch' as const,
  },
  body: {
    textAlign: 'center' as const,
    alignSelf: 'stretch' as const,
    marginTop: pd.ref.space.spacing20.px,
    lineHeight: 22,
  },
  actions: {
    alignSelf: 'stretch' as const,
    gap: pd.ref.space.spacing20.px,
    marginTop: pd.ref.space.spacing40.px,
  },
}));
